import React from 'react';

export interface FormFieldProps {
  label?: string;
  description?: string;
  error?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * Common wrapper component for all form fields
 * Provides consistent label, description, error display, and required indicator
 */
export default function FormField({
  label,
  description,
  error,
  required = false,
  className = '',
  children,
}: FormFieldProps) {
  return (
    <div className={`space-y-1 ${className}`}>
      {/* Label with optional required indicator */}
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {/* Input field (passed as children) */}
      {children}

      {/* Description text - shown below input */}
      {description && !error && (
        <p className="text-xs text-gray-500 mt-1">{description}</p>
      )}

      {/* Error message */}
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
}
